import { ADDRESSES, ADDRESSES_ACTIVE, ADDRESSES_CITIES, ADDRESSES_STATES,
  ADDRESS_CREATE, ADDRESS_UPDATE, ADDRESS_EXCLUDE, ADDRESS_IMPORT,
  NOTIFICATIONS_INCLUDE, PERK_DETAILS } from '@store/types'
import shortly from 'vuex-shortly'
import graphQL from '@graphQL'
import axios from 'axios'
import { toOptions } from '@helpers/options'
import PartnerQuery from '@graphQL/queries/Partner'

const state = {
  addresses: [],
  active: []
}

const getters = {
  [ADDRESSES_ACTIVE]: 'active',
  [ADDRESSES]: (state) => {
    const addresses = [ ...state.addresses ].map(
      (address) => ({
        status: state.active.includes(address.id) ? '1' : '0',
        ...address
      })
    )
    return addresses
  },
  [ADDRESSES_CITIES]: (state) => {
    const cities = state.addresses.map((address) => address.city)
    const options = toOptions(cities, { label: 'Todas' })
    return options
  },
  [ADDRESSES_STATES]: (state) => {
    const states = state.addresses.map((address) => address.state)
    const options = toOptions(states, { label: 'Todos' })
    return options
  }
}

const mutations = {
  [ADDRESSES]: 'addresses',
  [ADDRESSES_ACTIVE]: 'active'
}

const actions = {
  [ADDRESSES]: async ({ commit }, payload) => {
    const response = await graphQL(PartnerQuery, {
      id: payload.partner,
      includeDetails: false,
      includeAddresses: true
    })
    const addresses = response.data.data?.partner?.address || []
    commit(ADDRESSES, addresses)
  },
  [ADDRESS_CREATE]: async ({ commit, dispatch }, { perk, address }) => {
    const successMsg = 'Endereço adicionado com sucesso!'
    const errorMsg = 'Não foi possível criar o endereço'
    const response = await axios.post(`perks/${perk}/address/`, address)
    dispatch(PERK_DETAILS, { perkId: perk })

    if (response.data.success) {
      dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: successMsg })
    } else {
      dispatch(NOTIFICATIONS_INCLUDE, new Error(errorMsg))
    }
  },
  [ADDRESS_UPDATE]: async ({ commit, dispatch }, { perk, address, data }) => {
    const response = await axios.patch(`perks/${perk}/address/${address}`, data)
    dispatch(PERK_DETAILS, { perkId: perk })
    let notification = { type: '', message: '' }

    if (response.data.success) {
      notification.message = 'Endereço atualizado com sucesso!'
      notification.type = 'success'
    } else {
      notification.message = 'Não foi possível atualizar o endereço'
      notification.type = 'error'
    }

    dispatch(NOTIFICATIONS_INCLUDE, { ...notification })
  },
  [ADDRESS_EXCLUDE]: async ({ commit, dispatch }, { perk, address }) => {
    await axios.delete(`perks/${perk}/address/${address}`)
    dispatch(PERK_DETAILS, { perkId: perk })
  },
  [ADDRESS_IMPORT]: async ({ commit, dispatch }, { perk, file }) => {
    const successMsg = 'Endereços importados com sucesso!'
    const errorMsg = 'Não foi possível importar os endereços'
    const data = new FormData()
    data.append('file', file)

    const response = await axios.post(`perks/${perk}/import`, data)
    dispatch(PERK_DETAILS, { perkId: perk })

    if (response.data.success) {
      dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: successMsg })
    } else {
      dispatch(NOTIFICATIONS_INCLUDE, new Error(errorMsg))
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/addresses.js